<template>
  <nav class="bg-white relative z-50">
    <div class="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
      <div class="flex h-20 items-center justify-between">
        <div class="flex flex-1 items-center justify-between">
          <!-- Logo -->
          <router-link class="flex items-center" to="/">
            <img class="w-28 sm:w-32" :src="vueLogo" alt="AlgoPilot Logo" />
          </router-link>

          <!-- Desktop Links -->
          <div class="hidden md:flex items-center space-x-6">
            <router-link to="/home" class="nav-link" active-class="text-bright-blue">Home</router-link>
            <router-link to="/projects" class="nav-link" active-class="text-bright-blue">Projects</router-link>
            <router-link to="/services" class="nav-link" active-class="text-bright-blue">Services</router-link>
            <router-link to="/pricing" class="nav-link" active-class="text-bright-blue">Pricing</router-link>
            <router-link to="/about" class="nav-link" active-class="text-bright-blue">About</router-link>
            <a href="#contact" class="nav-link">Contact</a>
          </div>

          <!-- Mobile Hamburger -->
          <div class="md:hidden">
            <button @click="toggleMobileMenu" class="text-gray-700 hover:text-bright-blue">
              <font-awesome-icon :icon="['fas', 'bars']" class="text-2xl" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Overlay -->
    <transition name="fade">
      <div v-if="isMobileMenuOpen" @click="toggleMobileMenu" class="fixed inset-0 bg-black bg-opacity-40 z-40"></div>
    </transition>
    
    <!-- Mobile Sidebar -->
    <transition name="slide">
      <div v-if="isMobileMenuOpen" class="fixed inset-y-0 left-0 w-64 bg-white z-50 overflow-y-auto shadow-xl">
        <div class="flex flex-col space-y-2 p-6 text-left text-gray-800 font-medium">
          <router-link to="/home" class="mobile-link" @click="toggleMobileMenu">Home</router-link>
          <router-link to="/projects" class="mobile-link" @click="toggleMobileMenu">Projects</router-link>
          <router-link to="/services" class="mobile-link" @click="toggleMobileMenu">Services</router-link>
          <router-link to="/pricing" class="mobile-link" @click="toggleMobileMenu">Pricing</router-link>
          <router-link to="/about" class="mobile-link" @click="toggleMobileMenu">About</router-link>
          <a href="#contact" class="mobile-link" @click="toggleMobileMenu">Contact</a>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
import vueLogo from "@/assets/AlgoPilot.svg";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "NavBar",
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      vueLogo,
      isMobileMenuOpen: false,
    };
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
  },
};
</script>

<style scoped>
.nav-link {
  @apply text-gray-600 hover:text-bright-blue px-3 py-2 transition-colors duration-200 text-sm font-medium;
}

.mobile-link {
  @apply py-2 border-b border-gray-200 hover:text-bright-blue;
}

/* Fade transition for overlay */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Slide transition for mobile menu */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
}

.slide-enter-to,
.slide-leave-from {
  transform: translateX(0);
}
</style>